<mat-expansion-panel
  [expanded]="expanded"
  (opened)="open()"
  (closed)="close()"
  class="basket-discount-voucher-accordion-panel"
  >
  <mat-expansion-panel-header>
    <mat-panel-title>{{ "basket_add_voucher_code" | i18next }}</mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div class="voucher-input">
      <nx-ng-textfield
        [id]="'basket_voucher_code'"
        [name]="'basket_voucher_code'"
        [isRequired]="true"
        [placeholder]="'basket_enter_voucher_code_placeholder'"
        [(ngModel)]="voucherCode"
        [isLoading]="loading"
        [errorText]="error"
        [readonly]="applied"
        [successIcon]="applied"
        (enter)="handleApplyDiscount(voucherCode)"
        ></nx-ng-textfield>

        <nx-ng-action-button
          *ngIf="applied"
          [id]="'removeDiscount'"
          type="button"
          [attr.aria-controls]="'removeDiscount'"
          class="remove-button"
          (click)="handleRemoveDiscount(voucherCode)"
          [buttonLabelKey]="'button_remove'"
          [icon]="loading ? 'loading' : 'none'"
        >
        </nx-ng-action-button>

        <nx-ng-action-button
          *ngIf="!applied"
          [id]="'apply-voucher-code-to-basket'"
          [buttonLabelKey]="'basket_apply_voucher_code'"
          [theme]="'green-outlined'"
          [disabled]="loading || !voucherCodeValid"
          [icon]="loading ? 'loading' : 'none'"
          class="apply-voucher-code-to-basket"
          (click)="handleApplyDiscount(voucherCode)"
        >
        </nx-ng-action-button>
    </div>
  </ng-template>
</mat-expansion-panel>
